import type { ApiSideThread } from "../data/api/sideThreads";

// Which side threads this browser has read, in localStorage rather than the
// server: unread is a per-reader fact, and a per-browser approximation of it
// costs no schema. The panel stamps "now" while a thread is open; a thread is
// unread when the agent spoke after the stamp.

const key = (threadId: string): string => `tin.sideThread.read.${threadId}`;

export const markSideThreadRead = (threadId: string): void => {
  localStorage.setItem(key(threadId), new Date().toISOString());
};

export const isSideThreadUnread = (t: ApiSideThread): boolean =>
  t.last_message?.role === "agent" &&
  Date.parse(t.last_activity_at) >
    Date.parse(localStorage.getItem(key(t.public_id)) ?? "1970-01-01");
